import { RestResponse } from "@/business/shared/commons/rest/RestResponse";
import { restClient } from "@/business/shared/commons/rest/restClient";
import { updateEventUrl } from "../constants/urls";
import { getEnvVariable } from "@/business/shared/commons/envUtils/getEnvVariable";
import { UpdateEventRequest } from "../../domain/events";
import { DaccachErrorActions } from "@/business/shared/commons/DaccachError";

export const updateEventService = {
  async execute(token: string, request: UpdateEventRequest): Promise<void> {
    const url = getEnvVariable
      .execute("VUE_APP_DACCACH_URL")
      .concat(updateEventUrl);

    // const headers = {
    //   "web-token": token,
    //   Accept: "application/json",
    // };

    const headers = {
      "web-token": token,
      Accept: "application/json",
      "Content-Type": "application/json",
    };

    const response: RestResponse = await restClient().sendRequest(
      url,
      "PUT",
      JSON.stringify(request),
      headers
    );

    if (!response.isSuccess) {
      const errorMessage =
        response.statusCode == 422
          ? DaccachErrorActions().extractFormError(response.content)
          : response.content;
      throw DaccachErrorActions().createError(errorMessage);
    }
  },
};
